/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RequestTrackingResponse,
    RequestTrackingResponseFromJSON,
    RequestTrackingResponseFromJSONTyped,
    RequestTrackingResponseToJSON,
} from './RequestTrackingResponse';

/**
 * 
 * @export
 * @interface RequestTrackingPageResponse
 */
export interface RequestTrackingPageResponse {
    /**
     * 
     * @type {Array<RequestTrackingResponse>}
     * @memberof RequestTrackingPageResponse
     */
    data?: Array<RequestTrackingResponse>;
    /**
     * Total number of records matching the query
     * @type {number}
     * @memberof RequestTrackingPageResponse
     */
    total?: number;
    /**
     * Current page number (0-based)
     * @type {number}
     * @memberof RequestTrackingPageResponse
     */
    page?: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof RequestTrackingPageResponse
     */
    pageSize?: number;
}

export function RequestTrackingPageResponseFromJSON(json: any): RequestTrackingPageResponse {
    return RequestTrackingPageResponseFromJSONTyped(json, false);
}

export function RequestTrackingPageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestTrackingPageResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(RequestTrackingResponseFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
    };
}

export function RequestTrackingPageResponseToJSON(value?: RequestTrackingPageResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(RequestTrackingResponseToJSON)),
        'total': value.total,
        'page': value.page,
        'pageSize': value.pageSize,
    };
}

